export default __webpack_public_path__ + "static/media/image.code2futures.8a9ab338.png";